import Loading from 'vue-loading-overlay';
import Datepicker from 'vuejs-datepicker';
import Multiselect from 'vue-multiselect'

import { mapGetters, mapMutations } from 'vuex';

import { orderService } from '../../services/OrderService';
import { listService } from '../../services/ListService';
import { userService } from '../../services/UserService';
import { attachmentService } from '../../services/AttachmentService';

import SearchBox from '../../views/Controls/SearchBox';
import FinishOrder from './finishOrderComponent.vue';
import CancelOrder from './cancelOrderComponent.vue';
import EditPaymentComponent from './editPaymentComponent.vue';
//
import OfferComponent from './offerComponent.vue';
// Widgets


export default {
    name: 'TempOrderList',
    components: {
        Loading,
        SearchBox,
    },
    props: {
        caption: {
            type: String,
            default: 'Comenzi'
        },
    },
    data: () => {
        return {
            loading: true,
            loadingOrders: false,

            currentPage: 1,
            perPage: 10,
            perPageOptions: [
                { text: '10', value: '10' },
                { text: '20', value: '20' },
                { text: '50', value: '50' },
                { text: '100', value: '100' },
            ],
            formTitle: '',
            focusedRowObject: null,
            fields: [],
            items: [],
            searchFilter: '',

            totalRows: 0,
            firstRowOnPage: 0,
            lastRowOnPage: 0,

            itemToBeChanged: {},
            sortDesc: true,
            sortBy: 'CreatedOn',
            // search options
            searchOptions: [{
                Text: 'Orice',
                Value: 'All'
            }]

        }
    },
    computed: {
        ...mapGetters(
            {
                // general
                userProfile: 'user/profile',
                userHasRole: 'user/hasRole',
                orderTypeSettings: 'general/orderTypeSettings',
                appSettings: 'general/appSettings',
                settingsLoaded: 'general/settingsLoaded',
                typeSettings: 'general/typeSettings',
            }),

        roles() {
            return userService.roles;
        },

    },
    created() {
        // clear order
        this.clearOrder();

        // get users
        var model = this;
        userService.getUsers().then((response) => {
            model.users = response.data;
            model.loading = false;
        });

        //create columns
        this.fields = [
            { key: 'Type', label: 'Tip', sortable: true, thStyle: 'width:5%' },
            { key: 'OwnerName', label: 'Asigurat', sortable: true },
            { key: 'Detail1', label: 'Bun asigurat', sortable: true, thStyle: 'width:20%' },
            { key: 'Insurer', label: 'Valabilitate', sortable: true, thStyle: 'width:15%' },
            { key: 'CreatedOn', label: 'Data oferta', sortable: true, thStyle: 'width:20%' },
            { key: 'Id', label: '', thStyle: 'min-width:200px' },
        ];
        // read orders
        this.getTempOrders();
    },
    methods: {

        ...mapMutations(
            {
                clearOrder: 'order/clear',
            }),

        searchTextChanged: function (searchText) {
            this.searchFilter = searchText;
        },

        getTempOrders() {
            var model = this;
            this.loadingOrders = true;
            orderService.getTempOrders().then(response => {
                model.items = response.data;
                model.totalRows = model.items.length;
                model.loadingOrders = false;
            })
            .catch(e => {
                showErrorNotification(e);
            });
        },

        deleteButtonClick(dataItem) {
            if (dataItem != null) {
                var model = this;

                orderService.deleteTempOrder(dataItem.Id, dataItem.RowVersion)
                    .then(response => {
                        model.items = model.items.filter(x => x.Id != dataItem.Id);
                    })
            }
        },
        refreshButtonClick() {
            // refresh data
            this.getTempOrders();
        },

        editButtonClick(data) {
            if (data != null) {
                var redirectPath = '/crm/offer/edit/' + data.item.Id;
                this.$router.push({ path: redirectPath });
            }
        },

        getPdfOfferButtonClick: function (data) {
            window.location.href = 'api/Order/Pdf/' + data.item.Id;
        },

        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },


        deleteOrderButtonClick(data) {
            if (data != null) {
                this.itemToBeChanged = data.item;
                this.$refs['modalDelete'].show()
            }
        },

        zeroPad(num, places) {
            var zero = places - num.toString().length + 1;
            return Array(+(zero > 0 && zero)).join("0") + num;
        },

    },
    watch: {

    }
}
